import { Dialog, Transition } from '@headlessui/react';
import { IconAlertTriangle, IconRotate, IconX } from '@tabler/icons-react';
import { Fragment } from 'react';

export default function ConfirmationProsess({ isLoadingSubmit, isOpenModalProses, submitProses, closeModaProses }) {
  return (
    <>
      <Transition appear show={isOpenModalProses} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeModaProses}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-sm transform overflow-hidden rounded-lg bg-white p-6 sm:p-8 text-left align-middle shadow-xl transition-all">
                  <div className="flex flex-col items-center text-center">
                    {/* Icon Container */}
                    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 mb-5">
                      <IconAlertTriangle className="h-8 w-8 text-amber-600" aria-hidden="true" />
                    </div>

                    <Dialog.Title
                      as="h3"
                      className="text-lg font-bold leading-6 text-slate-900 mb-2"
                    >
                      Proses Transaksi
                    </Dialog.Title>
                    <p className="text-sm text-slate-500 mb-6 px-2">
                      Apakah anda yakin untuk memproses data pengeluaran hari ini? Tindakan ini akan mengubah status transaksi.
                    </p>

                    {/* Action Buttons */}
                    <div className="flex w-full gap-3 sm:flex-row flex-col">
                      <button
                        type="button"
                        onClick={closeModaProses}
                        disabled={isLoadingSubmit}
                        className="flex-1 w-full inline-flex justify-center rounded-md border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 focus-visible:ring-offset-2 transition-colors disabled:opacity-60"
                      >
                        Batal
                      </button>
                      <button
                        type="button"
                        onClick={submitProses}
                        disabled={isLoadingSubmit}
                        className="flex-1 w-full inline-flex items-center justify-center gap-2 rounded-md border border-transparent bg-gradient-to-r from-amber-500 to-amber-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:from-amber-400 hover:to-amber-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 transition-all disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed disabled:shadow-none"
                      >
                        {isLoadingSubmit ? (
                          <>
                            <IconRotate className="w-4 h-4 animate-spin" />
                            Memproses...
                          </>
                        ) : (
                          'Proses Data'
                        )}
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
